import { motion } from "framer-motion";
import { Phone, Zap } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site";
import Reveal, { EASE } from "@/components/Reveal";

export default function FinalCta() {
  return (
    <section id="contatti" className="relative overflow-hidden py-24 lg:py-36">
      <div
        aria-hidden="true"
        className="absolute left-1/2 top-1/2 h-[480px] w-[820px] -translate-x-1/2 -translate-y-1/2 animate-glow-breathe rounded-full bg-volt/10 blur-[150px]"
      />
      <Zap
        aria-hidden="true"
        size={520}
        className="absolute -right-32 top-1/2 -translate-y-1/2 text-volt/[0.04]"
        fill="currentColor"
      />

      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-volt">
            Contatti · Attivi adesso
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 font-display text-4xl font-black leading-[1.05] tracking-tight text-black sm:text-5xl lg:text-6xl">
            HAI UN EMERGENZA?
            <br />
            <span className="text-volt">NON ASPETTARE.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mx-auto mt-6 max-w-xl text-balance text-base text-slate-300 sm:text-lg">
            Un tecnico sta aspettando la tua chiamata. Il numero è gratuito e
            attivo 24 ore su 24, ogni giorno dell'anno.
          </p>
        </Reveal>

        <motion.div
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
          className="mt-11 flex flex-col items-center justify-center gap-4 sm:flex-row"
        >
          <a
            href={PHONE_TEL}
            data-testid="final-cta-call-button"
            className="group relative inline-flex h-16 w-full max-w-sm items-center justify-center gap-3 overflow-hidden rounded-full bg-volt px-8 font-display text-lg font-extrabold text-night shadow-[0_8px_50px_rgba(255,195,0,0.45)] transition-all duration-300 hover:scale-[1.04] hover:shadow-[0_8px_70px_rgba(255,195,0,0.65)] active:scale-95 sm:w-auto"
          >
            <span
              aria-hidden="true"
              className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full"
            />
            <Phone size={22} strokeWidth={2.5} className="relative transition-transform duration-300 group-hover:rotate-12" />
            <span className="relative">{PHONE_DISPLAY}</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
